import React from 'react'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import IconBg from 'app/GNNPage/components/IconBg'

type PanduanCardProps = {
  title: string
  text: string
  url: string
  btnText?: string
}

const PanduanCard = ({
  text,
  title,
  url,
  btnText = 'Unduh Panduan',
}: PanduanCardProps) => {
  return (
    <div className="bg-gray-0 p-6 rounded-lg border hover:shadow-sm transition-shadow">
      <div className="flex items-start space-x-4">
        <IconBg size="sm" className="bg-blue-10 flex-shrink-0">
          <Icon color="informational">article</Icon>
        </IconBg>
        <div className="flex-1 space-y-3">
          <Text variant="body-sm-bold">{title}</Text>
          <Text variant="body-sm" color="subdued">
            {text}
          </Text>
          <Button
            size="sm"
            color="white"
            onClick={() => {
              window.open(url, '_blank')?.focus()
            }}
          >
            {btnText}
            <Icon fontSize="sm" className="ml-1">
              open_in_new
            </Icon>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PanduanCard
